<template>
  <b-card
    title="Register New Account"
    sub-title="Registration is quick and easy."
  >
    <RegisterForm />
  </b-card>
</template>

<script>
export default {
  components: {
    RegisterForm: () => import('@/components/forms/auth/RegisterForm'),
  },
};
</script>
